// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607080955/js/" + chunkId + "." + {"44":"4aaf2dc2","225":"6ca224c4","481":"bd359bce","486":"c0544732","770":"b2146fd0"}[chunkId] + ".0.21882660217645078.chunk.js";
};